export default __webpack_public_path__ + "static/media/projects2.e65b4ea3.jpg";